import Success from './success';
import Fail from './fail';

export default {
    Success,
    Fail
}